import InfoModel from '../../../models/secure/InfoModel';

const getInfo = async (context, payload) => {
    let infoModel = new InfoModel();
    return infoModel.getInfo(payload).then(res => {
        context.commit('SET_INFO', res.data);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

export {
    getInfo
}
